/* 馬超傳・第 4 章：潼關（下）渭南決戰（建安十六年，211）
 * 史實：《武帝紀》「先以輕兵挑之，戰良久，乃縱虎騎夾擊，大破之，斬成宜、李堪等。遂、超等走涼州，楊秋奔安定，關中平。」
 *       《曹仁傳》「以仁行安西將軍，督諸將拒潼關，破超渭南。」《夏侯淵傳》「從征韓遂等，戰於渭南。」
 *       《張郃傳》「從破馬超、韓遂於渭南。」《徐晃傳》「遂破超等。」《許褚傳》「從討韓遂、馬超於潼關。」
 *       〈龐德傳〉「太祖破超於渭南，德隨超亡入漢陽。」
 * 流程：1. 曹軍的輕兵不斷出來挑戰，打了就退；追得越深（過了會語的地方），兩側的虎騎越容易包夾。
 *       2. 戰良久，曹操縱虎騎夾擊；成宜、李堪戰死（劇情），韓遂、楊秋各自逃走。
 *       3. 曹仁、夏侯淵、張郃、徐晃、許褚依序從不同方向殺出（王怪，不必打倒）；帶著龐德往西突圍，逃往涼州。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, vanish, TROOPS } from '../kit.ts';
import { MEN, band } from './machao_kit.ts';
import { XICAMP, CAOCAMP, TALK, EXIT } from '../maps/machao_weinan.ts';

const LV = 13, LONG = 50, DEEP = TALK[0] + 450;
const QING = { spec: TROOPS.wei, name: '輕兵', hp: 380, maxHp: 380, atk: 20, ms: 290 };
const HUQI = { spec: TROOPS.wei, name: '虎騎', hp: 700, maxHp: 700, atk: 34, ms: 320 };
const GENERALS = [['caoren', '曹仁', [CAOCAMP[0] - 600, CAOCAMP[1]]], ['xiahouyuan', '夏侯淵', [2400, 1300]], ['zhanghe', '張郃', [2000, 3800]], ['xuhuang', '徐晃', [1100, 1700]], ['xuchu', '許褚', [TALK[0] + 400, TALK[1] + 600]]];

export default {
  id: 'machao-4', map: 'machao_weinan', hero: 'machao',
  title: '第 4 章　潼關（下）：渭南決戰', year: '建安十六年（211）',
  brief: {
    quote: [{ text: '先以輕兵挑之，戰良久，乃縱虎騎夾擊，大破之，斬成宜、李堪等。', src: '《三國志·魏書·武帝紀》' }],
    text: '聯軍各部互相猜疑，曹操約期決戰。曹軍先派輕兵挑戰，打了就退。關西兵精悍，但追得太深，兩側就是曹操的虎騎。',
    goals: ['迎戰輕兵，不要追得太深', '虎騎夾擊：帶著龐德往西突圍', '逃出渭南，往涼州'],
  },
  words: { ally: '關西軍', foe: '曹軍' },
  stars: [
    { text: '挑戰時沒被虎騎包夾到', ok: (m) => !m.vars.caught },
    { text: '龐德沒有倒下', ok: (m) => !m.vars.pdDown },
    { text: '帶出 5 騎以上', ok: (m) => (m.vars.out || 0) >= 5 },
  ],
  steps: [
    { // 0. 輕兵挑之
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = XICAMP[0] + 1100; me.y = XICAMP[1];
        V.t0 = w.t; V.waveT = 3; V.qing = [];
        V.pd = ally(w, 'pangde', me.x - 80, me.y + 90, LV);
        V.side = [['韓遂', MEN.hansui, -260], ['成宜', MEN.chengyi, -130], ['李堪', MEN.likan, 130], ['楊秋', MEN.yangqiu, 260]].map(([n, s, dy]) => { const u = ally(w, s, me.x - 200, me.y + dy, LV - 2); u.name = n; u.hold = [me.x - 200, me.y + dy]; return u; });
        V.men = band(m, me, 10, '西涼騎', { hp: 640, atk: 26 });
        m.line('馬超', '曹賊約期決戰——關西兒郎，今日一雪前恥！');
        m.after(3, () => m.line('提示', `曹軍的輕兵打了就退。不要追過會語的地方太深：兩側埋著虎騎。`));
        m.mark('line', DEEP, TALK[1], '別追過這裡', true);
        m.obj('long', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        m.get('long').text = `迎戰輕兵（戰良久 ${Math.min(LONG, Math.floor(t))}/${LONG} 秒）`;
        // 一波波輕兵：上前挑戰，打幾秒就退
        if ((V.waveT -= dt) <= 0) {
          V.waveT = 10;
          for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', CAOCAMP[0] - 900 + (i % 2) * 80, TALK[1] - 240 + i * 120, QING); u.home = [me.x + 100, me.y]; u.born = w.t; V.qing.push(u); }
          m.line('曹軍', '關西鼠輩，敢出來一戰嗎！');
        }
        for (const u of V.qing) if (u.alive && !u.back && w.t - u.born > 9) { u.back = true; u.home = [CAOCAMP[0] - 300, u.y]; u.target = null; u.aggro = null; u.think = 2; }
        // 追太深：兩側的虎騎包夾過來
        if (me.x > DEEP && !V.flankT) {
          V.flankT = w.t;
          m.big('兩側有伏兵！');
          for (const s of [-1, 1]) {
            m.warn({ x1: me.x + 260, y1: me.y + s * 800, x2: me.x + 260, y2: me.y, w: 260, t: 1.4, col: '#ff5040', fn: (hit) => { for (const u of hit) if (u.team === 0) { m.hurt(u, 160, 1, { stagger: 0.4 }); if (u === me) V.caught = true; } } });
            for (let i = 0; i < 3; i++) { const u = m.foe('huangjin', me.x - 300 + i * 120, me.y + s * 900, HUQI); u.home = [me.x, me.y]; }
          }
        }
        if (V.flankT && w.t - V.flankT > 12) V.flankT = 0; // 冷卻過了，再追深還會被包
        return t >= LONG;
      },
    },
    { // 1. 縱虎騎夾擊
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('long'); m.unmark('line');
        m.big('虎騎夾擊！');
        m.card('戰良久，乃縱虎騎夾擊，大破之。', '《武帝紀》');
        V.huqi = [];
        for (const s of [-1, 1]) for (let i = 0; i < 6; i++) { const u = m.foe('huangjin', me.x - 600 + i * 220, me.y + s * 1100, HUQI); u.home = [me.x - 200, me.y]; V.huqi.push(u); }
        // 成宜、李堪戰死；韓遂、楊秋各自逃走
        m.after(4, () => {
          for (const u of V.side.slice(1, 3)) { w.fx({ k: 'boom', x: u.x, y: u.y, r: 120, col: '#c86a3a' }); u.hp = 0; u.alive = false; u.deadT = w.t; u.respawn = 1e9; }
          m.card('斬成宜、李堪等。', '《武帝紀》');
          for (const u of [V.side[0], V.side[3]]) { u.hold = [EXIT[0], u.y > me.y ? 3900 : 1300]; u.untargetable = true; m.after(8, () => vanish(w, u)); }
          m.line('韓遂', '撐不住了，各自走吧！');
        });
        m.after(7, () => { m.line('龐德', '將軍！往西突圍，回涼州！'); m.mark('exit', EXIT[0] + 150, EXIT[1], '往涼州'); m.obj('out', '帶著龐德往西突圍'); });
        // 五將依序殺出
        V.gens = [];
        GENERALS.forEach(([id, name, at], k) => m.after(5 + k * 4, () => {
          const u = boss(w, hero(id), at[0], at[1], { name, hp: 9000, atk: 46, armor: 10, ms: 245, gold: 0, xp: 0 });
          u.home = [me.x, me.y]; V.gens.push(u);
          m.big(`${name}殺到！`);
          w.dmgEvents.push({ x: u.x, y: u.y - 120, text: name, team: 1, src: u.id });
        }));
        V.t1 = w.t;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        for (const u of V.gens) if (u.alive && !(u.target && u.target.alive)) u.home = [me.x, me.y]; // 擋路、追著馬超
        for (const u of V.huqi) if (u.alive && !(u.target && u.target.alive)) u.home = [me.x, me.y];
        if (!m.get('out') || !m.near(me, EXIT[0] + 150, EXIT[1], 300)) return false;
        V.out = m.alive(V.men).length;
        return true;
      },
    },
    { // 2. 遂走涼州
      enter(m, w) {
        const V = m.vars;
        m.done('out'); m.unmark('exit');
        m.card('遂、超等走涼州，楊秋奔安定，關中平。', '《武帝紀》');
        m.after(3, () => m.card('太祖破超於渭南，德隨超亡入漢陽。', '《三國志·魏書·龐德傳》'));
        for (const u of w.units) if (u.team === 1 && u.alive) { u.untargetable = true; u.home = [CAOCAMP[0], CAOCAMP[1]]; u.target = null; }
        m.after(7, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('馬超陣亡'); return; }
    if (V.pd) { if (!V.pd.alive) V.pdDown = true; allyTick(w, V.pd, me, m.i === 0 ? 450 : 0); } // 突圍時龐德只跟著走
    for (const u of V.side || []) if (u.alive) allyTick(w, u, u.hold ? null : me, m.i === 0 ? 400 : 0);
  },
};
